// ClientTripSelect.jsx — pick WHICH of a client's trips an invoice/receipt is for.
// Trips are listed newest first; the value is the trip's real index in client.trips.
import React from "react";

const fmtDay = (d, withYear = true) =>
  d ? new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", ...(withYear ? { year: "numeric" } : {}) }) : "";

/** "17 Oct – 24 Oct 2026" (or just the start date if there's no end). */
export const tripDateRange = (t) => {
  if (!t?.tripStartDate) return "";
  if (!t.tripEndDate) return fmtDay(t.tripStartDate);
  return `${fmtDay(t.tripStartDate, false)} – ${fmtDay(t.tripEndDate)}`;
};

/** YYYY-MM-DD for <input type="date">. */
export const isoDay = (d) => (d ? new Date(d).toISOString().slice(0, 10) : "");

export const tripLabelLong = (t, i) => {
  const dest = (t?.destinations || []).filter(Boolean).join(", ") || `Trip ${i + 1}`;
  const dates = tripDateRange(t);
  const status = t?.progressStatus ? t.progressStatus.replace(/_/g, " ") : "";
  return [dest, dates, status].filter(Boolean).join(" · ");
};

export default function ClientTripSelect({ client, value, onChange }) {
  const trips = client?.trips || [];
  if (!trips.length) return null;
  // newest first, keeping the real index as the value
  const options = trips.map((t, i) => [t, i]).reverse();
  return (
    <div className="flex flex-col gap-1">
      <label className="text-xs font-bold text-slate-600 uppercase tracking-wider">
        Trip <span className="font-normal text-slate-400 normal-case">— which trip is this for?</span>
      </label>
      <select
        value={value === "" || value == null ? "" : String(value)}
        onChange={(e) => e.target.value !== "" && onChange(Number(e.target.value))}
        className="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 text-sm text-slate-700 bg-white outline-none focus:ring-2 focus:ring-[rgb(var(--brand-rgb)/0.3)] focus:border-[rgb(var(--brand-rgb))]"
      >
        <option value="">Select a trip…</option>
        {options.map(([t, i]) => (
          <option key={i} value={i}>{tripLabelLong(t, i)}</option>
        ))}
      </select>
    </div>
  );
}
